export class ConsoleLogger {
    static instance = new ConsoleLogger();
    $name = 'console-logger';
    constructor() { }
    debug(obj) {
        console.debug(obj);
    }
    error(obj) {
        console.error(obj);
    }
    info(obj) {
        console.info(obj);
    }
}
//# sourceMappingURL=console-logger.js.map